import axios from 'axios';
import { Capacitor } from '@capacitor/core';

// Web builds are served by the API server, so relative URLs work.
// Native builds load from capacitor://localhost (iOS) / https://localhost (Android)
// and must call the production API explicitly: set REACT_APP_API_URL at build time.
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';
export const isNative = Capacitor.isNativePlatform();

if (isNative && !API_BASE_URL) {
  console.warn('REACT_APP_API_URL is not set; API calls from the native app will fail.');
}

axios.defaults.baseURL = API_BASE_URL;
// Send the session cookie with every request
axios.defaults.withCredentials = true;

export default axios;
